import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import PageTitle from '../../shared/pagetitle/PageTitle.js';
import DataGrid from '../../shared/datagrid/DataGrid.tsx';
import BlockUI from '../../shared/blockui/BlockUI.tsx';
import {montarLinhasConcorrencia} from './acompanhamentoEstatistico.js';
import {ouTraco} from './inscricao/documentoInscricao.js';
import {PAGINACAO_PADRAO, textoSemRegistros} from './paginacao.js';
import useSWRFetch from '../../../hooks/useSWRFetch.js';
import {URL_ACOMPANHAMENTO_CONCORRENCIA} from '../../../constants/index.js';

const SWR_CONFIG = {revalidateOnFocus: false};
const PARAMS = {};
const TABLE_CONTAINER_PROPS = {component: 'div'};
const FILTER_OPTIONS = {filterByColumn: true};
const COMPARATOR_KEYS = ['idVaga'];

/*
 * Os números não usam ouTraco: 0 é um valor válido. Sem `sort` no DataGrid: a ordem
 * (razão inscritos por vaga, maior primeiro) já vem pronta de montarLinhasConcorrencia.
 */
const COLUNAS = [
    {label: 'Curso', field: 'curso', filterable: true, valueGetter: valor => ouTraco(valor)},
    {label: 'Campus', field: 'campus', filterable: true, valueGetter: valor => ouTraco(valor)},
    {label: 'Turno', field: 'turno', filterable: true, valueGetter: valor => ouTraco(valor)},
    {label: 'Vagas', field: 'vagas', filterable: false},
    {label: 'Inscritos', field: 'inscritos', filterable: false},
    {label: 'Inscritos por vaga', field: 'inscritosPorVagaTexto', filterable: false}
];

/*
 * Quadro "Concorrência por Curso": vagas, inscritos e inscritos por vaga de cada curso/campus/turno do processo
 * (título e conteúdo; o Grid item é do PainelEstatisticas e o Paper, da página).
 */
export default function PainelConcorrencia({idProcessoSeletivo}) {
    const {data, loading} = useSWRFetch(URL_ACOMPANHAMENTO_CONCORRENCIA(idProcessoSeletivo), PARAMS, SWR_CONFIG, undefined, true);
    const linhas = useMemo(() => montarLinhasConcorrencia(data), [data]);

    return (
        <>
            <PageTitle title='Concorrência por Curso'/>
            <BlockUI loading={loading}>
                <DataGrid
                    rows={linhas}
                    columns={COLUNAS}
                    comparatorKeys={COMPARATOR_KEYS}
                    filterOptions={FILTER_OPTIONS}
                    tableContainerProps={TABLE_CONTAINER_PROPS}
                    paginate
                    paginateOptions={PAGINACAO_PADRAO}
                    noRecordsText={textoSemRegistros(loading, 'Nenhuma vaga cadastrada no processo.')}/>
            </BlockUI>
        </>
    );
}

PainelConcorrencia.propTypes = {
    idProcessoSeletivo: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
